import { isNil } from 'lodash';

const toPdfExportTabId = (...parts: Array<string | number | null | undefined>): string =>
  parts
    .filter(p => !isNil(p) && p !== '')
    .map(p => String(p).replaceAll(/[^a-zA-Z0-9_-]/g, '_'))
    .join('__')
    .toLowerCase();

export default toPdfExportTabId;
